import { BundlePaymentPlan } from 'multirpc-sdk';

import { isPackagePlan } from './isPackagePlan';

export const isDealPlan = (plan?: BundlePaymentPlan) => !isPackagePlan(plan);
